Number.prototype.roundDown = function(n){
    if(angular.getObjVal((this).toString().split('.')[1],'length') <= 2){
        return this;
    }
    return Math.floor(this * 10 * 10) / 100;
};


// WEBPACK FOOTER //
// ./js/services/roundDown.js